import Text from './Text';
import Card from './Card';
import Whitespace from './Whitespace';
import SearchInput from './FormComponents/SearchInput';
import ViewBox from './ViewBox';
import BackgroundContainer from './BackgroundContainer';
import View from './View';

export {
  Text,
  Card,
  Whitespace,
  SearchInput,
  ViewBox,
  BackgroundContainer,
  View,
};



// WEBPACK FOOTER //
// ./src/components_new/common/index.js